import api from './api';

// Plans
const getPlans = () => api.get('/plan/plans/');
const getPlan = (planId) => api.get(`/plan/plans/${planId}/`);
const createPlan = (data) => api.post('/plan/plans/', data);
const updatePlan = (planId, data) => api.put(`/plan/plans/${planId}/`, data);
const deletePlan = (planId) => api.delete(`/plan/plans/${planId}/`);

export {
    getPlans,
    getPlan,
    createPlan,
    updatePlan,
    deletePlan,
};
